import AContainer from '../../library/ExtendedObjects/AContainer.js';
import gameData from '../../gameData.js';
import ABCyaPhaser from '@abcya/abcya_phaser';

export default class NavBar extends AContainer
{
    constructor(scene)
    {
        super(scene);

        this.navSounds = [];

        this.createNav();
        this.tweenInNav();
    }

    createNav()
    {
        this.bg = this.scene.addImage(0, 0, "Nav_Bar", this.scene.defaultAtlas, this);

        let txt;
        if(gameData.currentScene === "Game"){
            txt = ABCyaPhaser.Localization.instance.getLocalizedString("sortText");
        } else {
            txt = "Make your very own Fuzz Bug!";
        }
    
        this.instructions = this.scene.addText(0, -10, 24, "0xFFFFFF", this.scene.defaultFont, txt, this, true);
        this.instructions.setWordWrapWidth(625);
        this.instructions.setInteractive();
        this.instructions.on("pointerdown", ()=>{
            if(gameData.currentScene === "Game") {
                //this.scene.playSound("complete_pattern");
                this.playLevelSound();
            } else if(gameData.currentScene === "Customize") {
                this.scene.playSound("make_your_own_fb", 1, false, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
            } 
        });
        
        this.home = this.scene.addButton(this.bg.width/2 - 75, -10, "Btn_Menu", {}, ()=>{this.scene.pauseGame();}, this);
        this.home.setEnabled(false);
        
        this.setPosition(this.scene.mid.x, -100);
    }

    createLevel()
    {
        this.levelBg = this.scene.addImage(-this.bg.width/2 + 75, -10, "Progress_Area", this.scene.defaultAtlas, this);
        this.level = this.scene.addText(this.levelBg.x - 15, this.levelBg.y, 20, "0xFFFFFF", this.scene.defaultFont, gameData.level, this, true);
        this.levelMax = this.scene.addText(this.levelBg.x + 11, this.levelBg.y, 20, "0xFFFFFF", this.scene.defaultFont, "/10", this, true);
    }

    tweenOutInstructions()
    {
        if(gameData.level === 0){
            this.scene.addTween(this.instructions, 500, {alpha:0}, Phaser.Math.Easing.None,
                ()=>{this.updateLevel();});
        } else {
            this.scene.addTween(this.instructions, 500, {alpha:0}, Phaser.Math.Easing.None);
        }
        this.scene.addTween(this.instructions, 500, {alpha:0}, Phaser.Math.Easing.None);
    }

    updateLevel()
    {
        // console.log(gameData.level);
        if(gameData.level < 5) this.instructions.text = gameData.graphingQuestions[gameData.level].question;
        gameData.level++;

        this.playLevelSound();

        this.scene.addTween(this.instructions, 500, {alpha:1}, Phaser.Math.Easing.None,
            ()=>{if(gameData.level <= 5) this.scene.numPad.enableKeys();});

        if(gameData.level === 5){
            // console.log("GAME OVER");
            if(!gameData.customFuzzbug) gameData.gameOver = true;
        }
        else if(gameData.level === 6){
            // console.log("GAME OVER");
            gameData.gameOver = true;

            if(gameData.customFuzzbug) this.scene.createTrueEnding();
        }
    }

    toggleMute()
    {    
        //console.log(gameData.gameMuted);
        this.scene.playSound("click");

        if(!gameData.gameMuted){
            //console.log("muting");
            //this.scene.sound.setVolume(0);
            if(gameData.jingle) gameData.jingle.pause();

            this.mute.visible = false;
            this.soundBtn.visible = true;

            this.mute.setEnabled(false);
            this.soundBtn.setEnabled(true);
            
            gameData.gameMuted = true;
        } else {
            //console.log("unmuting");
            //this.scene.sound.setVolume(1);
            if(gameData.jingle) gameData.jingle.resume();

            this.mute.visible = true;
            this.soundBtn.visible = false;

            this.soundBtn.setEnabled(false);
            this.mute.setEnabled(true);
            
            gameData.gameMuted = false;
        }
    }

    playLevelSound()
    {
        if(gameData.level === 1) {
            this.scene.playSound("how_many_fb_see", 1, false, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
        }
        else if(gameData.level === 2) {
            this.scene.playSound("how_many1", 1, false, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE).once(Phaser.Sound.Events.COMPLETE, ()=>{
                this.scene.playSound(gameData.graphingQuestions[gameData.level-1].vials[0].name.toLowerCase(), 1, false, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE).once(Phaser.Sound.Events.COMPLETE, ()=>{
                this.scene.playSound("how_many2", 1, false, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
            })});
        }
        else if(gameData.level === 3) {
            this.scene.playSound("combined1", 1, false, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE).once(Phaser.Sound.Events.COMPLETE, ()=>{
              this.scene.playSound(gameData.graphingQuestions[gameData.level-1].vials[0].name.toLowerCase(), 1, false, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE).once(Phaser.Sound.Events.COMPLETE, ()=>{
                this.scene.playSound("combined2", 1, false, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE).once(Phaser.Sound.Events.COMPLETE, ()=>{
                  this.scene.playSound(gameData.graphingQuestions[gameData.level-1].vials[1].name.toLowerCase(), 1, false, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE).once(Phaser.Sound.Events.COMPLETE, ()=>{
                    this.scene.playSound("combined3", 1, false, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
                  });
                });
              });
            });
        }
        else if(gameData.level === 4) {
            this.scene.playSound("many_more1", 1, false, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE).once(Phaser.Sound.Events.COMPLETE, ()=>{
              this.scene.playSound(gameData.graphingQuestions[gameData.level-1].vials[0].name.toLowerCase(), 1, false, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE).once(Phaser.Sound.Events.COMPLETE, ()=>{
                this.scene.playSound("many_more2", 1, false, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE).once(Phaser.Sound.Events.COMPLETE, ()=>{
                  this.scene.playSound(gameData.graphingQuestions[gameData.level-1].vials[1].name.toLowerCase(), 1, false, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE).once(Phaser.Sound.Events.COMPLETE, ()=>{
                    this.scene.playSound("many_more3", 1, false, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
                  });
                });
              });
            });
        }
        else if(gameData.level === 5) {
            this.scene.playSound("many_fewer1", 1, false, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE).once(Phaser.Sound.Events.COMPLETE, ()=>{
              this.scene.playSound(gameData.graphingQuestions[gameData.level-1].vials[0].name.toLowerCase(), 1, false, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE).once(Phaser.Sound.Events.COMPLETE, ()=>{
                this.scene.playSound("many_fewer2", 1, false, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE).once(Phaser.Sound.Events.COMPLETE, ()=>{
                  this.scene.playSound(gameData.graphingQuestions[gameData.level-1].vials[1].name.toLowerCase(), 1, false, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE).once(Phaser.Sound.Events.COMPLETE, ()=>{
                    this.scene.playSound("many_fewer3", 1, false, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
                  });
                });
              });
            });
        }
    }

    tweenInNav()
    {
        if(gameData.currentScene === "Game"){
            this.scene.playSound("sort_by_color", 1, false, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
        } else {
            this.scene.playSound("make_your_own_fb", 1, false, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
        }

        if(gameData.level === 0){
            this.scene.addTween(this, 1000, {y:this.bg.height/2}, Phaser.Math.Easing.Quadratic.Out,
                ()=>{
                    this.home.setEnabled(true);
                });
        } else {
            this.y = this.bg.height/2;
            this.home.setEnabled(true);
        }
    }

    tweenOutNav()
    {
        this.scene.addTween(this, 1000, {y:-this.bg.height/2}, Phaser.Math.Easing.Quadratic.Out);
    }

    disableNav()
    {
        //console.log("disabling buttons");
        this.home.setEnabled(false);
        if(this.mute) this.mute.setEnabled(false);
        if(this.soundBtn) this.soundBtn.setEnabled(false);
    }

    enableNav()
    {
        //console.log("enabling buttons");
        this.home.setEnabled(true);
        if(this.mute) this.mute.setEnabled(true);
        if(this.soundBtn) this.soundBtn.setEnabled(true);
    }

    cleanUp(scene)
    {
        //console.log("cleaning UP");
        this.scene.playSound("click");
        
        this.disableNav();

        this.home.destroy();
        this.instructions.destroy();
        this.bg.destroy();

        if(this.mute){
            this.mute.destroy();
            this.soundBtn.destroy();
        }

        if(gameData.currentScene === "Game"){
            if(scene === "Intro") this.scene.cleanUp(scene);
        }
        else if(gameData.currentScene === "Customize"){
            this.scene.cleanUp("Intro");
        }
    }
}